import { IncidenteDTO } from "@/application/dto/incidentes/IncidenteDTO";
import { IHttpClient } from "@/application/ports/IHttpClient";
import { Incidente } from "@/domain/entities/incidente";
import { API_ENDPOINTS } from "../config/api.config";
import { IIncidenteRepository } from "@/domain/repositories/IIncidenteRepository";
import { IncidentesParamsDTO } from "@/application/dto/incidentes/IncidenteParamsDTO";
import { CreateIncidenteDTO } from "@/application/dto/incidentes/CreateIncidenteDTO";
import { IncidenteIdDTO } from "@/application/dto/incidentes/IncidenteId.DTO";
import { UpdateIncidenteDTO } from "@/application/dto/incidentes/UpdateIncidenteDTO";
import { ChangeIncidenteDTO } from "@/application/dto/incidentes/ChangeIncidenteDTO";

export class IncidenteRepository
  implements IIncidenteRepository {

  constructor(
    private readonly httpClient: IHttpClient
  ) { }
  findAll(): unknown {
    throw new Error("Method not implemented.");
  }

  async create(data: CreateIncidenteDTO): Promise<Incidente> {
    const response = await this.httpClient.post<IncidenteDTO>(
      API_ENDPOINTS.incidentes.base,
      data
    );

    return this.mapToEntity(response.data);
  }
  async update(
    id: string,
    incidente: Partial<Incidente>
  ): Promise<Incidente> {
    const response = await this.httpClient.put<IncidenteDTO>(
      API_ENDPOINTS.incidentes.byId(id),
      incidente as unknown as UpdateIncidenteDTO
    );

    return this.mapToEntity(response.data);
  }
  async change(
    id: string,
    incidente: ChangeIncidenteDTO
  ): Promise<Incidente> {
    const patch: ChangeIncidenteDTO = {
      estado: Number(incidente.estado),
      responsable: Number(incidente.responsable),
      tipo_responsable: Number(incidente.tipo_responsable),
      id_visita: Number(incidente.id_visita)
    };

    const response = await this.httpClient.patch<IncidenteDTO>(
      API_ENDPOINTS.incidentes.byId(id),
      patch
    );

    return this.mapToEntity(response.data);
  }

  async getincidentes(params?: IncidentesParamsDTO): Promise<Incidente[]> {

    const response = await this.httpClient.get<IncidenteDTO[]>(
      API_ENDPOINTS.incidentes.base,
      {
        params,
      }
    );
    console.log(params);
    return response.data.map((dto) => this.mapToEntity(dto));
  }

  async findById(
    id: string
  ): Promise<Incidente | null> {

    const response =
      await this.httpClient.get<
        IncidenteIdDTO
      >(
        API_ENDPOINTS.incidentes.byId(id)
      );

    return this.mapDetalleToEntity(
      response.data
    );
  }

  private mapToEntity(
    dto: IncidenteDTO
  ): Incidente {

    return {
      id: dto.id,
      equipo: dto.equipo,
      estado: dto.estado,
      tipo: dto.tipo,
      prioridad: dto.prioridad,
      iniciado: new Date(dto.iniciado),
      creador: dto.creador,
      contador: 0,
      contacto: "",
      telefono: 0,
      responsable: dto.responsable ?? "",
      tipo_responsable: dto.tipo_responsable ?? 0,
      ult_actualizacion: new Date(),
      id_tipo: 0,
      id_equipo: 0,
      ubicacion: dto.ubicacion ?? "",
      grupo: dto.grupo ?? ""
    };
  }
  
  private mapDetalleToEntity(dto: IncidenteIdDTO): Incidente {
    return {
      id: dto.id,
      equipo: dto.equipo,
      estado: dto.estado,
      tipo: dto.tipo,
      prioridad: dto.prioridad,
      iniciado: new Date(dto.iniciado),
      creador: dto.creador,
      contador: dto.contador,
      contacto: dto.contacto,
      telefono: dto.telefono,
      responsable: dto.responsable ?? "",
      ult_actualizacion: dto.ult_actualizacion ? new Date(dto.ult_actualizacion) : new Date(),
      tipo_responsable: dto.tipo_responsable ?? 0,
      id_tipo: dto.id_tipo,
      ubicacion: dto.ubicacion ?? "",
      grupo: dto.grupo ?? "",
      id_equipo: dto.id_equipo ?? 0
    };
  }
}
